<template>
  <div class="postion-org">
    <div class="postion-row" v-for="item in positionList" :key="item.id">
      <!-- <div> -->
      <el-tooltip
        :content="`${item.positionName}  ${item.orgName}`"
        placement="top"
        :open-delay="500"
      >
        <div class="row">
          <div class="postion-content">{{ item.positionName }}</div>
          <div class="org-content">
            {{ item.orgName }}
          </div>
        </div>
      </el-tooltip>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    positions: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    positions: {
      handler(val) {
        // console.log("val----->", val);
        this.positionList = val ? [...val] : [];
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      positionList: [],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.postion-org {
  display: flex;
  flex-direction: column;
  .postion-row {
    margin: 0;
    // border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    .row {
      display: flex;
      // justify-content: space-around;
    }
    &:first-child {
      // border-top: 1px solid #ebeef5;
    }
    &:hover {
      background-color: #409eff;
      color: #ffffff;
    }
  }
  .postion-content {
    // border-right: 1px solid #ebeef5;
    padding: 3px 5px 3px 10px;
    min-width: 80px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    font-weight: 600;
  }
  .org-content {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: 3px;
    flex: 1;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/childcomponents/positionOrg/index.vue